var _defs, _defs2, _defs3, _defs4, _defs5, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstant(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#F6FCE6"
    },
    width: 500,
    height: 500
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6FCE6"
    },
    d: "M289.359,63.336c-26.815-6.574-56.604-1.656-80.11,15.1c-13.768,9.814-24.589,23.223-37.882,33.672 c-18.189,14.298-40.259,22.523-61.215,32.328c-20.955,9.805-41.899,22.113-54.383,41.592 c-14.302,22.314-15.259,51.227-8.037,76.728c4.653,16.43,12.832,32.391,26.104,43.135c13.774,11.15,31.65,15.711,46.989,24.583 c19.397,11.22,34.042,28.875,50.022,44.585c15.979,15.71,34.997,30.321,57.288,32.612c25.291,2.6,49.558-11.308,68.223-28.571 c8.958-8.285,13.787-16.45,20.365-26.116c6.579-9.668,18.863-16.522,28.966-21.869c21.441-11.348,45.055-17.727,67.245-27.355 c9.455-4.102,18.825-8.952,26.012-16.339c9.86-10.135,14.74-24.213,16.729-38.213c3.185-22.419-0.949-46.809-15.693-63.995 c-15.6-18.185-40.214-25.683-58.894-40.686c-17.97-14.434-29.628-35.099-44.617-52.609 C323.956,77.303,307.325,67.74,289.359,63.336z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 45.805,
    y1: 286.4,
    x2: 454.195,
    y2: 286.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M310.302,215.517c0,1.549,1.256,2.805,2.805,2.805s2.805-1.256,2.805-2.805c0-1.549-1.256-2.805-2.805-2.805 S310.302,213.967,310.302,215.517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M69.429,78.243c0,1.549,1.256,2.805,2.805,2.805s2.805-1.256,2.805-2.805c0-1.549-1.256-2.805-2.805-2.805 S69.429,76.694,69.429,78.243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M72.234,314.296c0,1.549,1.256,2.805,2.805,2.805s2.805-1.256,2.805-2.805c0-1.549-1.256-2.805-2.805-2.805 S72.234,312.747,72.234,314.296z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 287.663,
    y1: 234.391,
    x2: 282.291,
    y2: 239.763
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 282.291,
    y1: 234.391,
    x2: 287.663,
    y2: 239.763
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 414.894,
    y1: 82.812,
    x2: 409.522,
    y2: 88.183
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 409.522,
    y1: 82.812,
    x2: 414.894,
    y2: 88.183
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 115.21,
    y1: 65.138,
    x2: 109.839,
    y2: 70.51
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 109.839,
    y1: 65.138,
    x2: 115.21,
    y2: 70.51
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#333333"
    },
    cx: 321.296,
    cy: 241.57,
    r: 1.582
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M264.716,96.065c0,0.873,0.708,1.582,1.581,1.582c0.873,0,1.582-0.708,1.582-1.582 c0-0.873-0.708-1.581-1.582-1.581C265.424,94.483,264.716,95.191,264.716,96.065z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M428.854,144.871c0,0.873,0.708,1.581,1.581,1.581c0.873,0,1.581-0.708,1.581-1.581 s-0.708-1.581-1.581-1.581C429.562,143.289,428.854,143.997,428.854,144.871z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#333333"
    },
    cx: 59.223,
    cy: 137.766,
    r: 1.581
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M282.395,302.801c0,0.873,0.708,1.581,1.581,1.581c0.873,0,1.582-0.708,1.582-1.581 c0-0.873-0.708-1.581-1.582-1.581C283.103,301.219,282.395,301.927,282.395,302.801z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B8C973"
    },
    d: "M120.696,370.21l141.078-18.669c5.361-0.71,9.132-5.631,8.422-10.992L236.855,88.6 c-0.71-5.361-5.631-9.132-10.992-8.422L84.785,98.847c-5.361,0.709-9.132,5.631-8.422,10.992l33.342,251.949 C110.414,367.148,115.335,370.919,120.696,370.21z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B8C973"
    },
    points: "78.736,156.106 82.683,157.601 79.928,136.778 76.505,139.248  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B8C973"
    },
    points: "90.819,94.299 89.324,98.246 110.147,95.491 107.677,92.068  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B8C973"
    },
    points: "81.491,176.929 85.439,178.424 82.683,157.601 79.26,160.071  "
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    d: "M132.204,109.212l2.981,3.672c1.669,2.056,4.287,3.098,6.913,2.75l32.792-4.34 c2.626-0.347,4.882-2.034,5.959-4.454l1.923-4.321c1.077-2.42,3.334-4.106,5.96-4.454l32.483-4.299 c4.17-0.552,7.998,2.381,8.55,6.552l30.771,232.523c0.552,4.17-2.381,7.998-6.552,8.55l-128.408,16.993 c-4.17,0.552-7.998-2.381-8.55-6.552L86.256,119.31c-0.552-4.17,2.381-7.999,6.552-8.55l32.483-4.299 C127.917,106.114,130.535,107.155,132.204,109.212z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_4_",
    style: {
      overflow: "visible",
      fill: "#F6FCE6"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000183965061732500365160000000879049836076491961_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_4_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 60.562,
    y: 158.688,
    transform: "matrix(-0.8942 -0.4477 0.4477 -0.8942 267.414 425.1994)",
    style: {
      clipPath: "url(#XMLID_00000183965061732500365160000000879049836076491961_)",
      fill: "#F6FCE6"
    },
    width: 246.798,
    height: 44.613
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6FCE6"
    },
    d: "M167.244,104.285c0.181,1.367,1.436,2.329,2.803,2.148c1.367-0.181,2.329-1.436,2.148-2.803 c-0.181-1.367-1.436-2.329-2.803-2.148C168.024,101.663,167.063,102.918,167.244,104.285z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 161.908,
    y1: 104.992,
    x2: 141.407,
    y2: 107.704
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8_",
    d: "M132.204,109.212l2.981,3.672c1.669,2.056,4.287,3.098,6.913,2.75l32.792-4.34 c2.626-0.347,4.882-2.034,5.959-4.454l1.923-4.321c1.077-2.42,3.334-4.106,5.96-4.454l32.483-4.299 c4.17-0.552,7.998,2.381,8.55,6.552l30.771,232.523c0.552,4.17-2.381,7.998-6.552,8.55l-128.408,16.993 c-4.17,0.552-7.998-2.381-8.55-6.552l0.339-52.601c0,0-57.371-33.104-62.587-70.322c-5.216-37.217,42.496-55.895,42.496-55.895 L86.256,119.31c-0.552-4.17,2.381-7.999,6.552-8.55l32.483-4.299C127.917,106.114,130.535,107.155,132.204,109.212z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000110448265744037628760000014833104395442326957_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_8_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#XMLID_00000110448265744037628760000014833104395442326957_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424242"
    },
    d: "M131.149,433.491c1.759-1.956,11.204-5.643,14.333-8.01c0.254-0.192,0.505-0.396,0.755-0.602 c2.141-1.769,4.087-4.05,5.111-6.73c0.967-2.53,1.107-5.291,1.189-7.999c0.066-2.179-1.353-9.324,0.647-10.39 c0.502-0.267,1.089-0.311,1.656-0.343c4.065-0.234,8.146-0.194,12.206,0.118c1.569,3.916-0.904,11.158-1.38,15.251 c-0.302,2.593,0.374,8.893,0.875,13.287c0.271,2.378,0.491,4.2,0.476,4.568c-0.16,4.015-7.973,3.447-10.623,3.771 c-4.377,0.536-8.587,2.925-12.951,3.533c-3.707,0.517-8.79,0.568-12.188-1.254C129.114,437.543,129.725,435.076,131.149,433.491 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424242"
    },
    d: "M180.022,414.678c-0.538-4.086-3.12-11.289-1.61-15.228c4.055-0.374,8.135-0.474,12.203-0.302 c0.568,0.024,1.155,0.059,1.661,0.318c2.016,1.035,0.704,8.202,0.803,10.379c0.123,2.706,0.305,5.465,1.31,7.98 c1.064,2.664,3.045,4.916,5.212,6.652c0.253,0.203,0.507,0.402,0.764,0.591c3.165,2.32,12.664,5.864,14.452,7.794 c1.448,1.563,2.095,4.021-0.029,5.201c-3.371,1.873-8.454,1.898-12.168,1.438c-4.373-0.542-8.618-2.868-13.003-3.338 c-2.654-0.284-10.458,0.402-10.678-3.61c-0.02-0.368,0.172-2.193,0.407-4.575C179.782,423.576,180.363,417.266,180.022,414.678z "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5B570"
    },
    d: "M188.282,269.228l-16.526,0.963l-16.539-0.714c0,0-10.369,22.445-10.242,39.324 c0.127,16.879,2.795,112.033,2.795,112.033s1.01,4.028,8.331,4.861c7.454,0.849,11.462-2.599,11.462-2.599l5.683-87.879 l5.005,87.798c0,0,4.06,3.387,11.5,2.426c7.307-0.944,8.257-4.986,8.257-4.986s1.235-95.183,1.108-112.062 C198.988,291.515,188.282,269.228,188.282,269.228z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M173.828,336.142c0.764-10.009,1.528-20.017,2.292-30.026c0.114-1.492,0.244-3.041,0.984-4.342 c0.911-1.602,2.596-2.578,4.203-3.479c2.319-1.3,4.637-2.599,6.956-3.899"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M182.05,297.536c1.236-9.628,1.063-19.435-0.515-29.013"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M178.686,299.817c1.236-9.628,1.063-19.435-0.515-29.013"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M149.858,288.416c1.448-0.318,2.638-1.334,3.658-2.41c3.039-3.205,5.156-7.274,6.036-11.602"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M188.757,381.338c0,0-5.97-15.364-7.391-23.512"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M173.542,209.84c0,0-14.366-1.614-22.882,1.227c-8.516,2.841-2.222,58.596-2.222,58.596 l-6.346,55.77c0,0,13.84,7.217,28.365,8.641l4.908-9.209l4.182,9.25c14.13-1.335,24.527-9.862,24.527-9.863 c0.321-0.288-4.346-26.202-5.219-49.197c-1.007-26.522-0.261-49.688-0.142-51.132c0.262-3.167,0.107-8.929-2.497-11.235 C191.246,208.288,173.542,209.84,173.542,209.84z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B8C973"
    },
    points: "172.386,210.281 161.324,210.365 175.366,235.024 183.591,210.914  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 169.685,225.048 175.255,220.337 179.15,223.932  "
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 175.255,
    y1: 220.337,
    x2: 175.366,
    y2: 235.024
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M175.366,235.024c0,0,1.115,28.637,1.549,43.097c0.434,14.46-1.549,46.745-1.549,46.745"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 167.19,300.34 153.607,297.717 153.735,301.384 167.218,304.13  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 184.173,299.491 197.715,296.664 197.642,300.333 184.201,303.281  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M176.937,271.75c-3.521-4.727-12.591-32.449-12.591-32.449l3.314-3.28c0,0-8.26-18.035-13.692-25.739"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M176.937,271.75c3.593-6.013,9.446-33.782,9.446-33.782l-3.896-2.37c0,0,6.505-17.261,9.441-24.759"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F2B27E"
    },
    points: "172.386,210.281 161.324,210.365 175.255,220.337 183.591,210.914  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5E4028"
    },
    d: "M188.545,144.008c-5.215-2.369-11.089-2.904-16.813-2.691c-4.041,0.15-8.155,0.681-11.788,2.458 c-3.633,1.776-6.746,4.969-7.607,8.92c-3.882,0.066-7.36,2.845-9.11,6.311c-1.749,3.466-2.011,7.505-1.692,11.375 c0.303,3.68,1.1,7.32,2.364,10.79c1.342,3.685,3.247,7.225,6.016,10.001c2.77,2.776,6.47,4.741,10.386,4.936 c4.097,0.205,8.123-1.53,11.301-4.123c7.203-5.877,9.195-16.597,18.405-19.996c2.891-1.067,5.761-1.521,7.686-4.181 c2.779-3.842,3.06-9.288,1.275-13.576C197.048,149.616,193.039,146.049,188.545,144.008z"
  }), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6_",
    d: "M164.37,209.715c0,2.83,1.292,5.408,7.825,5.408c6.533,0,7.825-2.487,7.825-5.408 c0-2.921,0.961-14.116,0.961-14.116h-17.571C163.409,195.599,164.37,206.885,164.37,209.715z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_6_",
    style: {
      overflow: "visible",
      fill: "#F2B27E"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000161616088377630619770000005899770570706510238_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_6_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.7,
      clipPath: "url(#XMLID_00000161616088377630619770000005899770570706510238_)",
      fill: "#F2B27E"
    },
    cx: 176.724,
    cy: 193.113,
    rx: 15.028,
    ry: 14.391
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2B27E"
    },
    d: "M151.63,175.737c-0.092-7.025,1.825-14.101,5.758-19.514c3.784-5.207,9.594-8.286,16.49-8.477 c6.896-0.191,12.239,1.984,16.509,6.146c4.706,4.586,7.016,11.404,6.463,17.952c-0.243,2.872-0.997,5.689-1.142,8.567 c-0.262,5.208,1.456,10.616-0.261,15.54c-1.481,4.246-5.391,7.344-9.687,8.675c-4.296,1.331-8.937,1.088-13.352,0.231 c-6.255-1.214-11.457-5.66-15.138-10.776C153.6,188.977,151.717,182.38,151.63,175.737z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E89777"
    },
    cx: 166.695,
    cy: 188.493,
    r: 4.602
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E89777"
    },
    cx: 190.944,
    cy: 188.493,
    r: 4.602
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M182.416,175.829c-0.271,2.507,0.162,5.086,1.237,7.367c0.593,1.259,1.397,2.519,1.316,3.908 c-0.055,0.94-0.547,1.846-1.306,2.403c-0.759,0.557-1.77,0.756-2.684,0.527"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M179.548,198.469c-1.416,0.091-2.857-0.141-4.049-0.65"
  }), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    d: "M173.178,192.546c-0.363,1.96,1.745,3.854,4.707,4.23c2.962,0.376,5.658-0.909,6.021-2.869 c0.363-1.96-2.097-1.947-5.06-2.323C175.883,191.208,173.541,190.586,173.178,192.546z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_5_",
    style: {
      overflow: "visible",
      fill: "#C9413A"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000013155412391000660100000014591954705267202445_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_5_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#XMLID_00000013155412391000660100000014591954705267202445_)",
      fill: "#F96C4B"
    },
    d: " M168.471,194.156c-0.789,1.985,1.671,4.48,5.494,5.574c3.823,1.094,7.561,0.371,8.35-1.613 c0.789-1.985-1.671-4.48-5.494-5.574C172.999,191.449,169.26,192.172,168.471,194.156z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#XMLID_00000013155412391000660100000014591954705267202445_)",
      fill: "#FFFFFF"
    },
    d: " M173.444,190.897c-0.235,1.335,2.077,2.084,5.03,2.439c2.953,0.355,5.331,0.469,5.566-0.867 c0.235-1.335-2.071-1.856-5.024-2.211C176.064,189.903,173.679,189.562,173.444,190.897z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_5_",
    style: {
      overflow: "visible",
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }))), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#38322E"
    },
    cx: 172.686,
    cy: 180.75,
    r: 2.228
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#38322E"
    },
    cx: 187.203,
    cy: 180.75,
    r: 2.228
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5E4028"
    },
    d: "M171.674,169.338c2.94-1.063,5.016,0.594,5.262,2.223c0,0-1.826-0.603-4.603-0.183 c-2.777,0.419-5.03,1.639-5.03,1.639S168.733,170.402,171.674,169.338z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5E4028"
    },
    d: "M189.243,169.338c-2.94-1.063-5.016,0.594-5.262,2.223c0,0,1.826-0.603,4.603-0.183 c2.777,0.419,5.03,1.639,5.03,1.639S192.184,170.402,189.243,169.338z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5E4028"
    },
    d: "M159.242,181.012c0.932-2.107,0.793-4.505,0.975-6.802c0.223-2.809,0.954-5.577,2.15-8.129 c1.345-2.872,3.725-5.72,6.895-5.839c1.57-0.059,3.072,0.572,4.545,1.118c2.156,0.8,4.37,1.443,6.619,1.922 c2.835,0.604,6.159,0.817,8.261-1.178c0.784-0.744,1.28-1.768,2.306-2.22c0.715-0.315,1.532-0.369,2.298-0.213 c0.607,0.124,1.181,0.373,1.768,0.573c0.145,0.049,0.307,0.096,0.448,0.036c0.287-0.122,0.251-0.536,0.155-0.833 c-2.892-8.999-13.63-15.014-22.81-14.37c-8.326,0.584-16.252,8.623-20.138,16.01c-2.58,4.904-3.282,10.737-2.105,16.139 c0.423,1.939,1.126,5.587,3.079,6.622C155.82,184.979,158.4,182.915,159.242,181.012z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2B27E"
    },
    d: "M147.687,183.806c1.766,4.75,6.096,7.589,8.268,6.533c1.686-0.82,1.951-3.982,0.969-7.777 c-0.982-3.794-3.817-8.622-6.678-7.901C147.384,175.383,145.921,179.056,147.687,183.806z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#F2B27E"
    },
    d: "M150.11,177.339c1.418,0.575,2.537,1.726,3.379,3.005 c1.131,1.717,1.83,3.717,2.018,5.764c-0.456-0.336-1.082-0.429-1.616-0.239c-0.575,0.204-0.833,0.643-1.114,1.137 c-1.264-0.528-2.367-2.368-2.943-3.543c-0.675-1.378-1.042-2.911-1.026-4.447C148.815,178.213,149.037,176.904,150.11,177.339 z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M150.661,211.067c0,0-8.874,2.166-11.699,8.416c-2.824,6.25-8.978,31.79-8.978,31.79 l-6.481-10.258c0,0-5.334-0.416-9.384,2.377c-4.05,2.793-3.082,5.593-3.082,5.593s15.812,33.899,27.25,24.387 c10.52-8.763,17.613-35.04,17.613-35.04L150.661,211.067z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M113.571,253.922c0,0,9.921,1.12,12.944-8.14"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M127.279,246.993c0,0,5.074,6.675,8.772,11.913"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M115.644,250.883c0.321,0.568,0.27,1.204-0.113,1.42c-0.383,0.216-0.953-0.069-1.274-0.637 c-0.321-0.568-0.27-1.204,0.113-1.42C114.753,250.029,115.323,250.314,115.644,250.883z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M143.092,218.389c0,0,4.912,6.919,5.714,15.691"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2B27E"
    },
    d: "M114.108,247.969c0,0-1.431-2.868-2.046-4.11c-1.185-2.393-2.823-2.035-5.482-2.138 c-2.576-0.099-5.04-0.97-7.358-2.045c-1.158-0.537-2.295-1.125-3.409-1.741c-1.297-0.717-2.609-1.41-3.852-2.218 c-1.196-0.777-2.457-1.568-3.392-2.662c-0.542-0.634-1.286-1.735-0.912-2.604c0.059-0.136,0.29-0.313,0.265-0.47 c-0.03-0.185-0.521-0.529-0.633-0.755c-0.304-0.609-0.288-1.398,0.129-1.952c-0.338-0.282-0.664-0.657-0.647-1.097 c0.017-0.455,0.413-0.825,0.847-0.961c0.452-0.141,0.997,0.043,1.406-0.199c0.527-0.311,0.619-0.868,1.35-0.927 c0.595-0.048,1.17,0.195,1.717,0.433c1.758,0.764,3.537,1.482,5.347,2.116c1.17,0.409,2.311,0.897,3.488,1.286 c0.723,0.239,1.606,0.664,2.376,0.587c-1.334-1.74-3.753-3.868-3.53-6.276c0.029-0.316,0.121-0.654,0.377-0.842 c0.398-0.292,0.961-0.08,1.376,0.187c1.405,0.901,2.06,2.411,3.326,3.453c1.259,1.037,2.727,1.782,4.109,2.635 c1.075,0.663,2.131,1.416,2.964,2.375c0.714,0.822,1.102,1.791,1.843,2.582c0.853,0.91,1.48,2.135,2.434,2.937 c1.439,1.211,5.961,8.449,5.961,8.449S119.989,248.28,114.108,247.969z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M98.302,228.911c-0.291,0.781-1.744,5.415-1.951,6.222"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M97.891,229.689c-2.993-0.882-6.627-2.467-9.233-4.184"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M97.275,231.97c-2.508-0.881-7.326-3.114-9.561-4.552"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M96.657,234.079c-1.917-0.763-6.648-2.978-8.418-4.038"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M98.652,235.365c3.057-1.01,6.431-1.036,9.504-0.075"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CC9864"
    },
    d: "M100.849,247.359l-28.764,1.171c-1.812,0.074-3.34-1.335-3.414-3.147l-1.599-39.278 c-0.074-1.812,1.335-3.34,3.147-3.414l28.764-1.171c1.812-0.074,3.34,1.335,3.414,3.147l1.599,39.278 C104.07,245.757,102.661,247.285,100.849,247.359z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.777,
    y: 203.13,
    transform: "matrix(-0.9992 0.0407 -0.0407 -0.9992 179.9052 442.4369)",
    style: {
      fill: "#FFFFFF"
    },
    width: 25.354,
    height: 39.835
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C6C6C6"
    },
    points: "92.49,197.966 89.925,198.07 89.814,195.353 78.855,195.8 78.966,198.517  76.401,198.621 74.251,204.667 95.124,203.817  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2B27E"
    },
    d: "M101.524,221.581c-0.415-0.267-0.979-0.479-1.376-0.187c-0.256,0.188-0.348,0.526-0.377,0.842 c-0.213,2.299,1.983,4.344,3.343,6.039l1.614-1.144l-1.835-4.297C102.495,222.367,102.066,221.929,101.524,221.581z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 75.939,
    y1: 208.827,
    x2: 94.968,
    y2: 208.052
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 76.007,
    y1: 212.112,
    x2: 95.036,
    y2: 211.337
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 76.075,
    y1: 215.398,
    x2: 95.103,
    y2: 214.623
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 76.142,
    y1: 218.684,
    x2: 95.171,
    y2: 217.908
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 76.21,
    y1: 221.969,
    x2: 95.239,
    y2: 221.194
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 76.278,
    y1: 225.255,
    x2: 95.306,
    y2: 224.479
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 76.345,
    y1: 228.54,
    x2: 95.374,
    y2: 227.765
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 76.413,
    y1: 231.826,
    x2: 95.442,
    y2: 231.05
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 76.481,
    y1: 235.111,
    x2: 95.509,
    y2: 234.336
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 76.548,
    y1: 238.397,
    x2: 95.577,
    y2: 237.622
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M194.629,211.665c0,0,11.703,1.796,14.66,8.578c2.956,6.782,16.616,39.626,11.638,45.918 c-4.978,6.292-32.724,8.747-32.724,8.747s-4.171-1.739-5.087-8.372c-0.916-6.633,1.885-7.463,1.885-7.463l17.551-6.212 c0,0-3.427-11.567-7.005-21.95C191.829,220.126,194.629,211.665,194.629,211.665z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M203.548,252.949c0,0,3.838-1.451,10.997,1.733"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M198.856,230.042c0,0,1.385-10.616,1.278-14.732"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M200.49,273.284c-6.649,1.125-12.288,1.624-12.288,1.624s-4.171-1.739-5.087-8.372c-0.916-6.633,1.885-7.463,1.885-7.463 l14.797-5.238"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M195.819,274.005c0,0,1.667-9.455-3.891-17.384"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M191.664,259.14c0.11,0.386-0.325,0.848-0.97,1.032c-0.646,0.184-1.259,0.02-1.368-0.366 c-0.11-0.386,0.325-0.848,0.97-1.032C190.942,258.59,191.554,258.754,191.664,259.14z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2B27E"
    },
    d: "M188.7,267.983c-0.07,0.414-0.17,0.822-0.302,1.221c-0.104,0.315-0.234,0.636-0.479,0.859 c-0.884,0.805-3.746-0.09-4.931,0.024c-3.246,0.312-6.17,1.705-9.263,2.656c-1.685,0.518-3.384,1.04-5.139,1.21 c-1.569,0.152-3.076,0.225-4.654,0.017c-1.868-0.247-3.735-0.493-5.603-0.74c-0.587-0.077-1.185-0.158-1.718-0.415 c-0.533-0.257-1-0.725-1.099-1.308c-0.634-0.167-1.279-0.339-1.833-0.689c-0.554-0.351-1.013-0.914-1.072-1.567 c-0.012-0.138-0.008-0.285-0.074-0.408c-0.055-0.105-0.155-0.18-0.233-0.27c-0.281-0.327-0.251-0.838-0.037-1.213 c0.214-0.374,0.574-0.639,0.933-0.878c-0.187-0.306-0.052-0.719,0.189-0.985c0.327-0.362,0.817-0.543,1.303-0.592 c0.485-0.049,0.974,0.022,1.457,0.092c0.939,0.136,1.879,0.27,2.82,0.402c0.734,0.103,1.472,0.205,2.213,0.189 c1.432-0.031,2.806-0.504,4.099-1.087c0.605-0.273,1.189-0.6,1.81-0.819c0.374-0.133,0.893-0.304,0.954-0.781 c0.07-0.549-0.524-0.936-1.049-1.113c-2.126-0.715-4.504-0.384-6.611-1.155c-0.326-0.119-0.678-0.303-0.774-0.637 c-0.165-0.573,0.509-1.006,1.064-1.222c1.975-0.767,4-1.546,6.119-1.597c3.634-0.089,7.433,1.031,10.87,2.1 c1.374,0.427,2.713,0.96,4.096,1.356c1.34,0.383,2.6,0.232,3.982,0.167c0.253-0.012,0.513-0.022,0.751,0.06 c0.358,0.124,0.613,0.437,0.827,0.749C188.579,263.448,189.071,265.788,188.7,267.983z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M153.422,266.549c2.731,0.999,5.599,1.623,8.497,1.85"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M152.843,268.94c3.091,0.905,6.294,1.426,9.512,1.546"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M155.899,271.404c2.433,0.557,4.913,0.908,7.406,1.048"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6D4D38"
    },
    d: "M443.829,364.116H307.264c-2.538,0-4.596,2.058-4.596,4.596v3.167c0,2.539,2.058,4.596,4.596,4.596 h11.305l3,53.679h5.525l3-53.679h36.419l2.441,43.679h5.525l2.441-43.679h16.286l3,53.679h5.525l3-53.679h26.584l2.441,43.679 h5.525l2.441-43.679h2.108c2.539,0,4.596-2.058,4.596-4.596v-3.167C448.426,366.173,446.368,364.116,443.829,364.116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5B570"
    },
    d: "M437.268,251.942H377.19c-9.348,0-16.927,7.578-16.927,16.926v69.848h93.931v-69.848 C454.195,259.52,446.616,251.942,437.268,251.942z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EDC188"
    },
    d: "M363.912,368.767h-59.194c-6.622,0-11.99-5.368-11.99-11.99v-20.203 c0-12.304,9.974-22.278,22.278-22.278h48.906V368.767z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5B570"
    },
    d: "M430.756,368.767H320.128v-14.245c0-8.729,7.076-15.805,15.805-15.805h94.823V368.767z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5B570"
    },
    d: "M339.391,430.143c-2.198,0.034-4.483,0.05-6.478-0.874c-1.936-0.896-3.384-2.581-5.176-3.738 c-1.328-0.857-2.85-1.399-4.416-1.611c-0.29,0.232-0.581,0.461-0.875,0.676c-3.64,2.669-14.566,6.745-16.623,8.964 c-1.665,1.797-2.41,4.625,0.033,5.982c3.877,2.155,9.723,2.183,13.996,1.654c5.03-0.624,9.912-3.299,14.956-3.839 c3.053-0.327,12.029,0.462,12.282-4.153c0.017-0.307-0.095-1.5-0.261-3.172c-0.274,0-0.548,0.004-0.822,0.008 C343.801,430.076,341.596,430.109,339.391,430.143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B27449"
    },
    d: "M345.844,412.647c0.619-4.699,3.588-12.984,1.852-17.516c-4.664-0.43-9.357-0.546-14.036-0.347 c-0.653,0.028-1.329,0.067-1.91,0.366c-2.319,1.191-0.81,9.434-0.924,11.938c-0.142,3.113-0.35,6.285-1.506,9.179 c-1.224,3.064-3.502,5.654-5.995,7.651c-0.001,0.001-0.003,0.002-0.004,0.003c1.566,0.212,3.088,0.753,4.416,1.611 c1.792,1.157,3.241,2.841,5.176,3.738c1.995,0.924,4.28,0.908,6.478,0.874c2.205-0.034,4.41-0.068,6.616-0.101 c0.273-0.004,0.548-0.008,0.822-0.008c-0.063-0.636-0.133-1.335-0.208-2.091C346.121,422.882,345.452,415.624,345.844,412.647z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5B570"
    },
    d: "M302.486,421.179c-2.198,0.034-4.483,0.05-6.478-0.874c-1.936-0.896-3.384-2.581-5.176-3.738 c-1.328-0.857-2.85-1.399-4.417-1.611c-0.289,0.232-0.58,0.461-0.875,0.676c-3.641,2.669-14.566,6.745-16.623,8.964 c-1.665,1.797-2.41,4.625,0.033,5.982c3.877,2.155,9.723,2.183,13.996,1.654c5.03-0.624,9.912-3.299,14.956-3.839 c3.053-0.327,12.029,0.462,12.282-4.153c0.017-0.307-0.095-1.5-0.261-3.172c-0.274,0.001-0.548,0.004-0.822,0.008 C306.896,421.112,304.691,421.145,302.486,421.179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B27449"
    },
    d: "M308.94,403.683c0.619-4.699,3.588-12.985,1.852-17.516c-4.664-0.43-9.357-0.546-14.036-0.347 c-0.653,0.028-1.329,0.067-1.91,0.366c-2.319,1.191-0.81,9.433-0.924,11.938c-0.142,3.113-0.35,6.285-1.507,9.179 c-1.224,3.064-3.502,5.654-5.995,7.651c-0.001,0.001-0.003,0.002-0.004,0.003c1.566,0.212,3.088,0.753,4.417,1.611 c1.792,1.157,3.241,2.841,5.176,3.738c1.995,0.924,4.28,0.908,6.478,0.874c2.205-0.034,4.41-0.068,6.616-0.101 c0.273-0.004,0.548-0.008,0.822-0.008c-0.063-0.636-0.133-1.335-0.208-2.09C309.216,413.918,308.547,406.66,308.94,403.683z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#605651"
    },
    d: "M301.509,341.153c1.698-2.932,4.799-5.181,7.538-7.049c9.193-6.272,20.155-10.168,30.835-13.014 c2.566-0.684,5.149-1.304,7.749-1.846c1.742-0.363,3.813,0.018,5.06-1.427c1.419-1.645,2.139-4.612,2.579-6.683 c0.028-0.133,0.062-0.277,0.17-0.359c0.094-0.072,0.221-0.078,0.339-0.081c13.005-0.37,26.632,0.901,39.315,4.062 c0.791,0.197,1.627,0.432,2.171,1.038c0.657,0.733,0.717,1.806,0.744,2.79c0.138,5.186,0.83,10.677-0.023,15.795 c-2.053,12.324-12.908,15.45-23.458,18.839c-7.583,2.436-21.409,4.98-21.409,4.98l-5.698,58.668c0,0-2.509,5.268-13.328,5.268 c-10.819,0-8.793-5.317-8.793-5.317s1.978-60.888,2.412-65.001c-0.76,0.082-4.776,0.283-5.516,0.345 c2.114,5.476-11.84,59.602-11.84,59.602s-4.797,5.274-12.899,3.638c-8.102-1.636-8.102-6.479-8.102-6.479 S298.799,345.832,301.509,341.153z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M327.701,351.813c0.12-1.136,0.416-2.238,0.951-3.279c1.549-3.014,4.533-5.416,7.174-7.42 c5.987-4.542,12.834-8.043,19.89-10.878"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M393.206,320.33c-0.303,5.222-0.711,10.67-3.411,15.15c-3.337,5.537-9.536,8.58-15.463,11.162 c-7.723,3.365-23.511,9.259-23.511,9.259s-2.587,31.76-5.917,63.536"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M390.495,333.902c-1.289-0.158-2.201-1.317-2.854-2.44c-2.019-3.471-3.009-7.533-2.814-11.544"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M328.32,348.171c-2.804,1.253-5.609,2.505-8.413,3.758c-0.984,9.593-12.753,62.154-12.753,62.154"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M352.49,357.35c-3.697-2.194-7.62-4.007-11.686-5.402"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M322.669,354.28c-3.327-1.837-6.884-3.256-10.562-4.215"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M353.501,331.068c0.056-3.222,0.758-6.431,2.052-9.382c0.09-0.205,0.339-0.44,0.487-0.272"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M355.857,330.131c1.278-2.754,2.752-5.418,4.407-7.963"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B27449"
    },
    d: "M346.932,303.176c-0.492,0.907-0.984,1.815-1.476,2.722c-1.275,2.351-2.65,5.206-4.813,6.887 c-2.024,1.573-4.999,2.147-7.364,3.191c-1.663,0.735-3.339,1.476-4.821,2.529c-1.326,0.941-2.549,1.902-3.638,3.131 c-1.289,1.454-2.577,2.908-3.866,4.362c-0.405,0.456-0.816,0.924-1.058,1.484c-0.242,0.561-0.29,1.241,0.027,1.762 c-0.381,0.558-0.768,1.128-0.963,1.775c-0.195,0.647-0.172,1.396,0.223,1.945c0.084,0.117,0.186,0.228,0.218,0.368 c0.028,0.12,0.001,0.245,0.001,0.368c0.002,0.445,0.371,0.823,0.79,0.97c0.42,0.147,0.879,0.11,1.32,0.053 c0.061,0.365,0.446,0.595,0.813,0.64c0.5,0.061,1.004-0.128,1.415-0.418c0.411-0.29,0.744-0.675,1.073-1.056 c0.64-0.74,1.282-1.48,1.925-2.218c0.502-0.576,1.008-1.154,1.596-1.642c1.137-0.944,2.526-1.503,3.928-1.922 c0.656-0.196,1.331-0.336,1.963-0.585c0.381-0.15,0.901-0.367,1.271-0.036c0.425,0.381,0.224,1.083-0.065,1.576 c-1.174,1.993-3.25,3.342-4.371,5.366c-0.173,0.313-0.323,0.694-0.173,1.019c0.259,0.557,1.076,0.44,1.655,0.233 c2.057-0.736,4.161-1.498,5.847-2.89c2.892-2.387,5.095-5.825,7.051-8.98c4.303-6.943,9.325-13.412,13.567-20.395 c2.242-3.691,3.847-6.929,4.657-11.165c0.835-4.363,1.308-8.785,1.774-13.199c0.487-4.609,0.965-9.242,0.72-13.87 c-0.021-0.389-0.062-0.815-0.336-1.092c-0.248-0.251-0.624-0.314-0.974-0.359c-2.387-0.302-4.812-0.299-7.198,0.011 c-0.486,0.063-0.987,0.145-1.399,0.411c-0.903,0.583-1.076,1.809-1.161,2.88c-0.56,7.014-1.12,14.027-1.681,21.041 c-0.101,1.267-0.205,2.547-0.581,3.761c-0.334,1.076-0.874,2.074-1.411,3.064C349.924,297.658,348.428,300.417,346.932,303.176z "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M321.646,334.52c1.453-2.623,3.266-5.047,5.371-7.182"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M319.58,333.048c1.797-2.793,3.941-5.363,6.367-7.632"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M320.296,329.064c1.52-2.078,3.215-4.027,5.062-5.82"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73C4C6"
    },
    d: "M349.474,272.53c1.206-5.073,3.346-9.885,5.592-14.666c0.994-2.116,2.064-4.238,3.65-5.957 c5.248-5.686,12.664-6.518,19.895-6.305c4.217,0.125,8.442,0.358,12.62,0.972c3.349,0.492,7.083,0.649,10.288,1.726 c6.253,2.1,11.084,7.519,13.68,13.445c3.263,7.449,3.66,15.791,4.009,23.916c0.02,0.463,0.031,0.961-0.222,1.349 c-0.281,0.43-0.81,0.613-1.302,0.76c-6.187,1.847-12.718,2.534-19.154,2.016c-0.251,3.951,0.293,7.953,0.254,11.961 c-0.013,1.754,0.046,3.7,1.259,4.967c0.385,0.402,0.891,0.746,1.033,1.285c0.374,1.426-2.001,2.209-2.114,3.679 c1.135,0.616,1.4,2.388,0.494,3.308c-0.315,0.32-0.768,0.613-0.753,1.061c0.011,0.338,0.295,0.594,0.457,0.89 c1.058,1.936-6.546,4.329-7.856,5.102c-2.613,1.54-5.435,2.601-8.378,3.377c-6.048,1.596-12.461,1.842-18.598,0.607 c-2.063-0.415-4.119-0.999-5.937-2.059c-2.022-1.179-4.551-3.53-5.274-5.822c-0.503-1.595-0.861-4.72,0.609-5.863 c0.398-0.31,0.917-0.504,1.166-0.942c0.176-0.31,0.181-0.685,0.172-1.042c-0.03-1.155-0.161-2.307-0.392-3.438 c-0.167-0.824-0.389-1.655-0.318-2.493c0.098-1.164,0.743-2.198,1.309-3.22c3.306-5.975,3.372-10.91,2.869-17.549 c-0.037-0.492-0.085-1.013-0.379-1.408c-0.26-0.349-0.672-0.545-1.067-0.728c-2.43-1.124-4.86-2.247-7.289-3.371 c-0.397-0.184-0.828-0.401-0.996-0.805c-0.118-0.283-0.081-0.603-0.041-0.907C348.931,275.076,349.173,273.795,349.474,272.53z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B27449"
    },
    d: "M393.89,249.735c-0.129,2.401-8.773,12.605-17.249,11.156c-8.477-1.448-5.45-8.611-3.495-11.24 c1.955-2.629,5.735-3.692,11.044-3.406C389.5,246.532,394.019,247.334,393.89,249.735z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B27449"
    },
    d: "M399.726,289.855c-0.024,0.734-0.049,1.469-0.073,2.203c-0.105,3.167,0.335,6.788-0.869,9.79 c-0.122,0.303-0.254,0.603-0.412,0.892c-0.988,1.814-2.42,3.34-3.836,4.844c-3.605,3.828-7.211,7.658-10.932,11.371 c-0.648,0.647-1.3,1.29-1.955,1.929c-1.963,1.913-4.267,4.156-6.875,5.155c-2.562,0.982-5.359,0.2-8.063,0.232 c-0.284,0.003-0.568,0.009-0.852,0.014c-1.537,0.026-3.076,0.091-4.575,0.416c-1.589,0.344-3.091,0.747-4.576,1.449 c-1.757,0.83-3.513,1.66-5.27,2.49c-0.552,0.26-1.114,0.528-1.557,0.948c-0.443,0.42-0.754,1.027-0.668,1.631 c-0.57,0.363-1.15,0.735-1.583,1.254c-0.434,0.519-0.707,1.216-0.56,1.876c0.031,0.14,0.081,0.282,0.056,0.424 c-0.021,0.121-0.095,0.226-0.143,0.339c-0.173,0.41,0.017,0.902,0.345,1.203c0.328,0.3,0.765,0.447,1.193,0.568 c-0.087,0.359,0.176,0.722,0.496,0.908c0.435,0.253,0.973,0.277,1.466,0.172c0.492-0.105,0.95-0.328,1.402-0.549 c0.88-0.429,1.761-0.857,2.643-1.282c1.554-0.75,2.546-1.234,4.251-0.912c1.968,0.371,3.902,0.9,5.862,1.311 c2.565,0.539,5.224,0.88,7.803,0.411c2.739-0.498,4.728-2.08,6.734-3.816c2.411-2.088,5.264-3.728,7.895-5.565 c5.489-3.833,10.816-7.899,15.961-12.184c3.054-2.543,6.214-5.372,7.985-9.004c2.084-4.274,2.281-10.537,2.986-15.252 c0.226-1.513,0.429-3.03,0.617-4.549C409.751,289.708,404.72,290.141,399.726,289.855z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M348.723,338.747c2.368-1.841,4.987-3.356,7.762-4.492"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M347.402,336.582c2.75-1.862,5.732-3.382,8.855-4.514"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M349.627,333.199c2.214-1.313,4.539-2.438,6.943-3.361"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M363.27,312.172c7.811,3.081,17.235,1.613,23.739-3.697"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M363.358,307.107c3.05,3.219,7.972,4.519,12.215,3.228"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M397.923,288.347c-0.507-0.156-1.014-0.312-1.522-0.468c-1.653-7.27-1.396-14.966,0.737-22.11"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M400.196,259.034c0.927-2,2.556-3.666,4.534-4.638"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M361.746,257.301c-0.052-1.562-0.105-3.124-0.157-4.686"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M357.993,281.329c0.356-2.453,0.813-4.892,1.369-7.309"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#38322E"
    },
    d: "M400.161,181.29c-3.396-2.077-7.491-2.679-11.47-2.8c-3.979-0.121-7.978,0.192-11.935-0.251 c-3.956-0.443-7.984-1.742-10.78-4.576c-0.422,3.24,0.794,6.651,3.171,8.893c-7.803,2.275-13.306,9.55-15.813,17.282 c-1.461,4.505-2.087,9.396-0.933,13.989c1.154,4.593,4.285,8.831,8.698,10.551c3.134,1.222,6.599,1.116,9.956,1.327 c3.357,0.211,6.924,0.866,9.342,3.204c1.765,1.707,2.677,4.081,3.826,6.251c1.361,2.571,3.186,5,5.712,6.445 c3.15,1.802,7.544,1.991,10.818,0.405c-2.127-1.262-2.563-4.715-1.191-6.731c1.268,1.827,3.707,2.753,5.868,2.229 c-1.686-2.002-1.489-5.061-0.337-7.412c1.151-2.351,3.08-4.209,4.788-6.193c2.788-3.238,5.076-6.968,6.255-11.075 c1.179-4.107,1.195-8.612-0.387-12.582c-1.703-4.276-4.973-7.239-8.381-10.157C404.431,187.574,403.555,183.366,400.161,181.29z "
  }), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9_",
    d: "M391.327,247.902c0,2.83-1.292,5.408-7.825,5.408s-7.825-2.487-7.825-5.408s-0.961-14.116-0.961-14.116 h17.571C392.288,233.786,391.327,245.072,391.327,247.902z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_9_",
    style: {
      overflow: "visible",
      fill: "#B27449"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000072992038286478412630000017839214447959718313_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_9_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.5,
      clipPath: "url(#XMLID_00000072992038286478412630000017839214447959718313_)",
      fill: "#B27449"
    },
    cx: 378.973,
    cy: 231.3,
    rx: 15.028,
    ry: 14.391
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B27449"
    },
    d: "M404.066,213.925c0.092-7.025-1.825-14.101-5.759-19.514c-3.784-5.208-9.594-8.286-16.49-8.477 c-6.896-0.191-12.239,1.984-16.509,6.146c-4.706,4.586-7.016,11.404-6.463,17.952c0.243,2.872,0.997,5.689,1.142,8.567 c0.262,5.208-1.456,10.616,0.261,15.54c1.481,4.246,5.392,7.344,9.687,8.675c4.296,1.331,8.937,1.088,13.352,0.231 c6.255-1.214,11.457-5.66,15.138-10.776C402.097,227.165,403.979,220.567,404.066,213.925z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M373.28,214.016c0.271,2.507-0.162,5.086-1.237,7.367c-0.593,1.259-1.397,2.519-1.317,3.908 c0.055,0.94,0.547,1.846,1.306,2.403c0.759,0.557,1.77,0.756,2.684,0.527"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M373.932,233.091c2.896,0.316,5.907-0.624,8.109-2.531"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M377.133,235.736c0.985,0.032,1.978-0.259,2.79-0.818"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#38322E"
    },
    cx: 383.011,
    cy: 218.937,
    r: 2.228
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#38322E"
    },
    d: "M370.722,218.937c0,1.23-0.997,2.228-2.228,2.228c-1.23,0-2.228-0.997-2.228-2.228 c0-1.23,0.997-2.228,2.228-2.228C369.724,216.71,370.722,217.707,370.722,218.937z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A55D47"
    },
    d: "M393.604,226.681c0,2.542-2.061,4.602-4.602,4.602c-2.542,0-4.602-2.061-4.602-4.602 c0-2.542,2.06-4.602,4.602-4.602C391.544,222.079,393.604,224.139,393.604,226.681z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A55D47"
    },
    cx: 364.753,
    cy: 226.681,
    r: 4.602
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#38322E"
    },
    d: "M384.022,207.525c-2.94-1.064-5.016,0.594-5.262,2.223c0,0,1.826-0.603,4.603-0.183 c2.777,0.419,5.03,1.638,5.03,1.638S386.964,208.589,384.022,207.525z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#38322E"
    },
    d: "M366.454,207.525c2.94-1.064,5.016,0.594,5.262,2.223c0,0-1.826-0.603-4.603-0.183 c-2.777,0.419-5.03,1.638-5.03,1.638S363.512,208.589,366.454,207.525z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#38322E"
    },
    d: "M398.937,211.71c-1.818-2.344-4.144-4.693-4.166-7.66c-0.792,3.183-0.127,6.699,1.771,9.373 c-4.948-4.395-8.22-10.631-9.024-17.2c-3.672,4.758-9.652,7.645-15.661,7.56c2.05-1.924,3.435-4.543,3.872-7.321 c-2.416,4.243-6.826,6.866-10.554,10.02c-1.84,1.557-3.538,3.277-5.08,5.13c-0.16,0.193-3.212,3.89-3.291,3.573 c-3.799-15.14,7.444-29.896,22.036-33.57c9.809-2.47,19.362,2.724,25.237,10.517c4.605,6.108,6.94,16.102,2.813,23.014 c-0.862,1.444-3.012,4.731-4.98,3.271c-0.925-0.686-0.779-2.338-1.105-3.327C400.402,213.866,399.724,212.724,398.937,211.71z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B27449"
    },
    d: "M408.01,221.994c-1.766,4.75-6.096,7.589-8.267,6.533c-1.686-0.82-1.951-3.983-0.969-7.777 c0.982-3.794,3.817-8.622,6.678-7.901C408.313,213.57,409.776,217.243,408.01,221.994z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#B27449"
    },
    d: "M405.587,215.527c-1.418,0.575-2.537,1.726-3.379,3.005 c-1.131,1.717-1.83,3.717-2.017,5.764c0.456-0.336,1.082-0.429,1.616-0.239c0.575,0.204,0.833,0.643,1.114,1.137 c1.264-0.528,2.367-2.368,2.943-3.543c0.675-1.378,1.042-2.911,1.026-4.447C406.882,216.4,406.66,215.091,405.587,215.527z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EDC188"
    },
    d: "M442.205,368.767h-59.194v-32.193c0-12.304,9.974-22.278,22.278-22.278h48.906v42.481 C454.195,363.399,448.827,368.767,442.205,368.767z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5B570"
    },
    d: "M299.498,130.261h-63.379c-6.752,0-12.226,5.474-12.226,12.226v36.176 c0,6.752,5.474,12.226,12.226,12.226h8.038c-0.347,7.234-6.092,12.598-6.092,12.598c11.25,0.461,19.087-7.806,22.664-12.598 h38.769c6.753,0,12.226-5.474,12.226-12.226v-36.176C311.724,135.735,306.25,130.261,299.498,130.261z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 248.705,
    y1: 149.808,
    x2: 289.111,
    y2: 149.808
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 243.653,
    y1: 159.779,
    x2: 294.163,
    y2: 159.779
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 248.705,
    y1: 169.75,
    x2: 289.111,
    y2: 169.75
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73C4C6"
    },
    d: "M367.938,77.345H326.72c-9.835,0-17.807,7.972-17.807,17.807l0,0 c0,9.835,7.973,17.807,17.807,17.807h1.457c-0.347,7.234-6.092,12.598-6.092,12.598c9.844,0.403,17.074-5.876,21.124-10.662 c1.051-1.242,2.611-1.936,4.238-1.936h20.49c9.835,0,17.807-7.972,17.807-17.807v0C385.745,85.317,377.772,77.345,367.938,77.345z "
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M338.616,95.445c0,1.64-1.329,2.969-2.969,2.969c-1.64,0-2.969-1.329-2.969-2.969s1.329-2.969,2.969-2.969 C337.286,92.476,338.616,93.805,338.616,95.445z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.798,95.445c0,1.64-1.329,2.969-2.969,2.969c-1.64,0-2.969-1.329-2.969-2.969s1.329-2.969,2.969-2.969 C350.469,92.476,351.798,93.805,351.798,95.445z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.98,95.445c0,1.64-1.329,2.969-2.969,2.969c-1.64,0-2.969-1.329-2.969-2.969s1.329-2.969,2.969-2.969 C363.651,92.476,364.98,93.805,364.98,95.445z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2272 -0.9738 0.9738 0.2272 -260.7411 394.6634)",
    style: {
      fill: "#73C4C6"
    },
    cx: 118.303,
    cy: 361.622,
    rx: 26.016,
    ry: 26.016
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 104.882,
    y: 352.643,
    style: {
      fill: "#FFFFFF"
    },
    width: 22.715,
    height: 17.958
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "135.725,367.937 135.725,355.308 124.387,361.637  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstant);
export default __webpack_public_path__ + "static/media/instant.b1be21027b578cb64ab8973a005cd5db.svg";
export { ForwardRef as ReactComponent };